import { render } from "./languageView.vue?vue&type=template&id=1c64e52d"
import script from "./languageView.vue?vue&type=script&lang=js"
export * from "./languageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__